/* src/app/components/lead-details/consumer-rates/consumer-rates.component.css */
.ant-form-item {
  margin-bottom: 5px;
}
.service-details-header {
  background-color: #a8e4e14d !important;
  font-weight: 600;
  color: black;
}
th,
td {
  padding: 5px 11px !important;
}
.approval-required {
  color: #b7791f;
  margin-left: 6px;
  cursor: help;
}
.service-code-line {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.approval-checkbox-slot {
  flex: 0 0 22px;
  display: flex;
  align-items: center;
}
/*# sourceMappingURL=consumer-rates.component-WN25ZDNW.css.map */
